import React from 'react';
import {NavigasjonPortlet} from '@gjensidige/service-types/types/common/navigasjonsportlet';

export type LazyComponent = React.LazyExoticComponent<React.ComponentType<unknown>>;

export type ModernRouteEntries = [
    string,
        Route & {
        component: LazyComponent;
    }
][];

export interface Route {
    title: string;
    path: string;
    assets: string[];
    chatEnabled: boolean;
    mountElementId?: string;
}

export interface Route {
    title: string;
    path: string;
    assets: string[];
    chatEnabled: boolean;
    mountElementId?: string;
}

export type MappedBedrift = {
    commercial: BedriftstilgangWindow[];
    broker: BedriftstilgangWindow[];
};

export enum WindowLinkKeys {
    STARTSIDE_DIREKTE = 'startSideDirekte',
    STARTSIDE_PRIVAT = 'startSidePrivat',
    STARTSIDE_MEGLER = 'startSideMegler',
    KONSERNOVERSIKT = 'detaljertOversiktForsikrings',
    KONSERNOVERSIKT_MEGLER = 'detaljertOversiktForsikringsMegler',
    KUNDEFORHOLDOVERSIKT_PRIVAT = 'kundeforholdoversiktPrivat',
    KUNDEFORHOLDOVERSIKT_BEDRIFT = 'kundeforholdoversiktBedrift'
}

export type WindowLinks = Pick<NavigasjonPortlet, WindowLinkKeys>;

export type BedriftstilgangWindow = {
    id: string;
    partref: string;
    navn: string;
    direkte: boolean;
    pensjon: boolean;
};

export type  Proposal = {
    productTypeId: string;
    productName: string;
    proposalNumber: string;
    paymentFees: number;
    insuredObjects: any;
}
